import { appTypeInjectionKey } from '#shared'
import { computed, inject, unref } from 'vue'
import { useRoute } from 'vue-router'
import { appChatIdInjectionKey } from './app-chat-id-injection-key'

export function useChatId() {
  const appType = inject(appTypeInjectionKey)
  const appChatId = inject(appChatIdInjectionKey)

  if (appType === 'full-screen') {
    const route = useRoute()
    const chatId = computed(() => Number(route.params.id))

    return chatId
  }

  if (appType === 'embedded') {
    if (!appChatId) {
      throw new Error('App chat id is not provided')
    }

    if (typeof unref(appChatId) !== 'number') {
      throw new Error('App chat id is not a number')
    }

    const chatId = computed(() => unref(appChatId))

    return chatId
  }

  throw new Error('Unknown app type')
}
